<template>
    <div class="column is-three-quarters right-side theme-style">
        <gallery-box v-bind:lot="lot"></gallery-box>
        <div class="columns"v-if="!isMobile">
            <div class="content column is-two-thirds main-image-column">
                <div class="equipment-section card">
                    <div class="card-header">Equipments</div>
                    <table class="table">
                        <tr>
                            <td>Carrier</td>
                            <td>Air Suspension</td>
                            <td>AM/FM Radio</td>
                            <td>Bumper Guard</td>
                            <td>CD Player</td>


                        </tr>
                        <tr>
                            <td>PBD</td>
                            <td class="active">Power Steering</td>
                            <td>Roof Rails</td>
                            <td>Sunproof</td>
                            <td>Aero</td>
                        </tr>
                        <tr>
                            <td class="active">Airbag</td>
                            <td>Half Leather Seats</td>

                            <td>Genuine Player</td>
                            <td class="active">Air Conditioner</td>
                            <td>Fabric Seats</td>
                        </tr>
                        <tr>
                            <td>Coil Spring</td>

                            <td class="active">ABS</td>
                            <td>Leather Seats</td>
                            <td>One Owner</td>
                            <td>Power Door Locks</td>

                        </tr>
                        <tr>
                            <td>LED</td>
                            <td>Service Record</td>
                            <td>Turbo</td>
                            <td>Air brake</td>
                            <td class="active">Alloy Wheels</td>
                        </tr>

                        <tr>

                            <td>Parallel Import</td>
                            <td>Power Seats</td>
                            <td class="active">Power Windows</td>
                            <td>CD Changer</td>
                            <td>DVD</td>
                        </tr>
                        <tr>
                            <td>Jack</td>
                            <td>Rear Spoiler</td>
                            <td class="active">Spare Tire</td>
                            <td colspan="2">TV/Navigation System</td>
                        </tr>
                    </table>

                    <table class="table" v-if="isMobile">
                        <tr>
                            <td>Carrier</td>
                            <td>Air Suspension</td>
                        </tr>
                        <tr>
                            <td>AM/FM Radio</td>
                            <td>Bumper Guard</td>
                        </tr>
                        <tr>
                            <td>CD Player</td>
                            <td>PBD</td>
                        </tr>
                        <tr>
                            <td class="active">Power Steering</td>
                            <td>Roof Rails</td>
                        </tr>
                        <tr>
                            <td>Sunproof</td>
                            <td>Aero</td>
                        </tr>
                        <tr>
                            <td class="active">Airbag</td>
                            <td>Half Leather Seats</td>
                        </tr>
                        <tr>
                            <td>Genuine Player</td>
                            <td class="active">Air Conditioner</td>
                        </tr>
                        <tr>
                            <td>Fabric Seats</td>
                            <td>Coil Spring</td>
                        </tr>
                        <tr>
                            <td class="active">ABS</td>
                            <td>Leather Seats</td>
                        </tr>
                        <tr>
                            <td>One Owner</td>
                            <td>Power Door Locks</td>
                        </tr>
                        <tr>
                            <td>LED</td>
                            <td>Service Record</td>
                        </tr>
                        <tr>
                            <td>Turbo</td>
                            <td>Air brake</td>
                        </tr>
                        <tr>
                            <td class="active">Alloy Wheels</td>
                            <td>Parallel Import</td>
                        </tr>
                        <tr>
                            <td>Power Seats</td>
                            <td class="active">Power Windows</td>
                        </tr>
                        <tr>
                            <td>CD Changer</td>
                            <td>DVD</td>
                        </tr>
                        <tr>
                            <td>Jack</td>
                            <td>Rear Spoiler</td>
                        </tr>
                        <tr>
                            <td class="active">Spare Tire</td>
                            <td colspan="2">TV/Navigation System</td>
                        </tr>
                    </table>

                </div>
            </div>
        </div>
        <div class="other-section" v-if="!isMobile">
            <translate-box v-bind:lot="lot"></translate-box>
            <comments-box v-bind:lot="lot"></comments-box>
        </div>
    </div>
</template>

<script>
    import GalleryBox from './GalleryBoxStock'
    import CarSpecs from './CarSpecsStock'
    import AucInfo from './AucInfoStock'
    import CommentsBox from '../Auctions/Lot/CommentsBox.vue'
    import TranslateBox from '../Auctions/Lot/Details/TranslationBox'

    export default {
        props: ['lot'],
        components: {
            galleryBox: GalleryBox,
            CarSpecs,
            AucInfo,
            commentsBox: CommentsBox,
            TranslateBox,
        },
        computed: {
            isMobile() {
                return document.documentElement.clientWidth < 450;
            }
        }
    }
</script>

<style scoped>
    .column {
        max-width: 100%;
    }

    .columns {
        margin-left: 0;
        margin-right: 0;
        margin-top: 0;
        margin-bottom: 0;
    }

    .equipment-section .card-header {
        background: #192939;
        padding: 10px;
        color: #fff;
    }
</style>




// WEBPACK FOOTER //
// src/components/StockCars/RightSideStock.vue